import { render, staticRenderFns } from "./downloadFileWithApi.vue?vue&type=template&id=1d18f155&scoped=true"
import script from "./downloadFileWithApi.vue?vue&type=script&lang=js"
export * from "./downloadFileWithApi.vue?vue&type=script&lang=js"
import style0 from "./downloadFileWithApi.vue?vue&type=style&index=0&id=1d18f155&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d18f155",
  null
  
)

export default component.exports